/**
 * Функция обновляет количество товара
 * @param response
 */
export default function (response) {
    // загрузим информацию о кнопке корзины
    $.request('onShopUpdateCartButton');
    $.request('onShopUpdateCartButtonMobile');
}